export class JobTitle {
    code: string;
    name: string;
    sortOrder: number;
}



// WEBPACK FOOTER //
// ./src/app/models/jobTitle.ts